import type { TransformedSearchAd } from '../get-data/transform/searchAds';

export type SearchAdsState = TransformedSearchAd[];

export const UPDATE_SEARCH_ADS = 'UPDATE_SEARCH_ADS';

export const updateSearchAds = (payload: TransformedSearchAd[]) => ({
    type: UPDATE_SEARCH_ADS,
    payload,
});

type Action = ReturnType<typeof updateSearchAds>;

export default function searchAdsReducer(state: TransformedSearchAd[] = [], action: Action) {
    return action.type === UPDATE_SEARCH_ADS ? action.payload || [] : state;
}
